// import Headphones from '../../../../../../assets/images/product-image-headphones.png'

import DatatableComponent from "../../../../../../../components/common/DatatableComponent/DatatableComponent"
import Headphones from "../../../../../../../assets/images/product-image-headphones.png"
import { Input } from "reactstrap"

const All = () => {
  const data = [
    { bannerImg: "", campaignName: "Summer Sale", select: <Input type="checkbox" /> },
    { bannerImg: "", campaignName: "Summer Sale", select: <Input type="checkbox" /> },
    { bannerImg: "", campaignName: "Summer Sale", select: <Input type="checkbox" /> },
    { bannerImg: "", campaignName: "Summer Sale", select: <Input type="checkbox" /> },
    { bannerImg: "", campaignName: "Summer Sale", select: <Input type="checkbox" /> },
  ]

  const columns = [
    {
      name: "Banner",
      cell: (row) => <img src={row.bannerImg} alt="" width={60} height={90} />,
      grow: 0.5,
    },
    { name: "Compaign Name", selector: (row) => row.campaignName },
    { name: "Select", selector: (row) => row.select },
  ]

  return (
    <div>
      <div style={{ backgroundColor: "#FBBD34", padding: ".5rem", color: "white", display: "inline-block", marginBottom: '1rem' }}>Total Banners: 10</div>

      <DatatableComponent columns={columns} data={data} type={"gray-bordered"} />
    </div>
  )
}

export default All
